<template>
    <form class="row brochure" v-on:submit.prevent="SubmitBrochureRequest">
        <template v-if="this.submitSuccess">
            <div class="col-12">
                <span class="success">{{this.requestBrochureSuccess}}</span>
            </div>
        </template>
        <template v-if="this.submitFailure">
            <div class="col-12">
                <span class="failure">{{this.inputFormSubmitFailure}}</span>
            </div>
        </template>
        <div class="row" v-if="!this.submitSuccess">
            <div class="col-md-6">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           id="fname"
                           placeholder=" "
                           v-model="v$.leadObj.firstName.$model"
                           @blur="v$.leadObj.firstName.$touch()" />
                    <label for="fname" class="form-label">{{formLabel.firstName}}</label>
                    <div class="error">
                        <template v-if="v$.leadObj.firstName.$error">
                            <span v-for="(err, index) in v$.leadObj.firstName.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           id="lname"
                           placeholder=" "
                           v-model="v$.leadObj.lastName.$model"
                           @blur="v$.leadObj.lastName.$touch()" />
                    <label for="lname" class="form-label">{{formLabel.lastName}}</label>
                    <div class="error">
                        <template v-if="v$.leadObj.lastName.$error">
                            <span v-for="(err, index) in v$.leadObj.lastName.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <input type="email"
                           class="form-control"
                           id="email"
                           placeholder=" "
                           v-model="v$.leadObj.email.$model"
                           @blur="v$.leadObj.email.$touch()" />
                    <label for="email" class="form-label">{{formLabel.email}}</label>
                    <div class="error">
                        <template v-if="v$.leadObj.email.$error">
                            <span v-for="(err, index) in v$.leadObj.email.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <input type="tel"
                           class="form-control"
                           id="phone"
                           placeholder=" "
                           v-model="v$.leadObj.phone.$model"
                           @blur="v$.leadObj.phone.$touch()" />
                    <label for="phone" class="form-label">{{formLabel.phone}}</label>
                    <div class="error">
                        <template v-if="v$.leadObj.phone.$error">
                            <span v-for="(err, index) in v$.leadObj.phone.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           id="address"
                           placeholder=" "
                           v-model="v$.leadObj.street.$model"
                           @blur="v$.leadObj.street.$touch()" />
                    <label for="address" class="form-label">{{formLabel.streetAddress}}</label>
                    <div class="error">
                        <template v-if="v$.leadObj.street.$error">
                            <span v-for="(err, index) in v$.leadObj.street.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           id="city"
                           placeholder=" "
                           v-model="v$.leadObj.city.$model"
                           @blur="v$.leadObj.city.$touch()" />
                    <label for="city" class="form-label">{{formLabel.city}}</label>
                    <div class="error">
                        <template v-if="v$.leadObj.city.$error">
                            <span v-for="(err, index) in v$.leadObj.city.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <states-dropdown :CountryCode="this.country"
                           v-model="state"
                           :onchange="selectedState"
                           id="state"
                           @blur="v$.state.$touch()" />
                    <label for="state" class="form-label">{{formLabel.state}}</label>
                    <div class="error">
                        <template v-if="v$.state.$error">
                            <span v-for="(err, index) in v$.state.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <input type="text"
                           class="form-control"
                           id="zipcode"
                           placeholder=" "
                           v-model="v$.leadObj.postalCode.$model"
                           @blur="v$.leadObj.postalCode.$touch()" />
                    <label for="zipcode" class="form-label">{{formLabel.zipcode}}</label>
                    <div class="error">
                        <template v-if="v$.leadObj.postalCode.$error">
                            <span v-for="(err, index) in v$.leadObj.postalCode.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <country-dropdown v-model="country"
                             :oncountryload="InitialSelect"
                             :onchange="selectedCountry" />
                    <label for="country" class="form-label">{{formLabel.country}}</label>
                    <div class="error">
                        <template v-if="v$.country.$error">
                            <span v-for="(err, index) in v$.country.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <select id="interested" name="interested" class="form-control" v-model="v$.leadObj.boat_1_Interest__c.$model" placeholder=" ">
                        <option v-for="(model, index) in this.InterestedModels" :key="index" :value="model.value">
                            {{model.label}}
                        </option>
                    </select>
                    <label for="interested" class="form-label">What boat model are you interested in?</label>
                    <div class="error">
                        <template v-if="v$.leadObj.boat_1_Interest__c.$error">
                            <span v-for="(err, index) in v$.leadObj.boat_1_Interest__c.$errors" :key="index" class="error text-danger validate">
                                {{ err.$message }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <select v-model="leadObj.consumer_s_Purchase_Intent__c" placeholder=" " name="when" class="form-control" id="when">
                        <option value=""></option>
                        <option value="As Soon as Possible">As Soon as Possible</option>
                        <option value="3 to 5 months">3 to 5 months</option>
                        <option value="6+ months">6+ months</option>
                        <option value="I'm just browsing">I'm just browsing</option>
                    </select>
                    <label for="when" class="form-label">When are you looking to purchase?</label>
                </div>
            </div>
            <div class="col-md-12">
                <button class="btn-submit" value="Submit" type="submit" :disabled="isSubmitting">{{formLabel.submit}}</button>
            </div>
            <div class="hidden">
                <input type="hidden"
                       id="BROCURE_LEAD_SOURCE"
                       name="BROCURE_LEAD_SOURCE"
                       v-model="leadSource" />                
                <input type="hidden"
                       id="loading-time"
                       name="loading-time"
                       :value="this.unixTimestamp" />
                <input type="text"
                       style="display: none"
                       id="hpValue"
                       name="hpValue"
                       v-model="hpvalue" />
            </div>
        </div>
    </form>
</template>
<script>
    import CountryDropdown from "../atoms/CountryDropdown.vue";
    import StatesDropdown from "../atoms/StatesDropdown.vue";
    import getEndPoint, { leadAPI } from "../../constants/api.config";
    import { salesforcelead } from "../../constants/form-model-config";
    import useValidate from "@vuelidate/core";
    import { required, email, helpers } from "@vuelidate/validators";
    import getBrandDetails from '../../constants/brand.config';
    import {inputFormSubmitFailure, requestBrochureSuccess, formLabel} from '../../constants/labels.config'
    export default {
        name: "RequestBrochure",
        components: {
            CountryDropdown,
            StatesDropdown,
        },
        data() {
            return {
                v$: useValidate(),
                state: "",
                country: "",
                interestedBoat: "",
                InterestedModels: getBrandDetails(window.BRAND,'models'),
                leadSource: "Request Brochure - Web Form",
                hpvalue: "",
                requestTime: "",
                leadID: "",
                leadObj: { ...salesforcelead },
                submitSuccess: false,
                submitFailure: false,
                requestBrochureSuccess,
                inputFormSubmitFailure,
                isSubmitting:null,
                formLabel
            };
        },
        validations() {
            return {
                leadObj:{
                    firstName: {
                        required: helpers.withMessage("First name cannot be empty", required),
                    },
                    lastName: {
                        required: helpers.withMessage("Last name cannot be empty", required),
                    },
                    email: {
                        required: helpers.withMessage(
                            "Email address cannot be empty",
                            required
                        ),
                        email: helpers.withMessage("Invalid email address", email),
                    },
                    phone: {
                        required: helpers.withMessage("Phone cannot be empty", required),
                    },
                    street: {
                        required: helpers.withMessage("Address cannot be empty", required),
                    },
                    city: { required: helpers.withMessage("City cannot be empty", required) },
                    
                    postalCode: {
                        required: helpers.withMessage("Zipcode required", required),
                    },
                    boat_1_Interest__c: {
                        required: helpers.withMessage("Please select a boat model", required),
                    },
                },
                state: { required: helpers.withMessage("Please select", required) },
                country: { required: helpers.withMessage("Please select", required) },
            };
        },
        computed: {
            unixTimestamp: function () {
                return Math.round(new Date().getTime() / 1000);
            },
        },
        methods: {
            selectedCountry: function (event) {
                this.country = event.target.value;
            },
            InitialSelect: function (data) {
                this.country = data;
            },
            selectedState: function (event) {
                this.state = event.target.value;
            },
            getBoatModels(data) {
                let modelNames = [];
                data.models.forEach(element => {
                    modelNames.push(
                        {
                            ModelName: element,
                        }
                    );
                });

                return modelNames;
            },
            SubmitBrochureRequest(e) {
                this.submitSuccess = false;
                this.submitFailure = false;
                this.isSubmitting=true;
                this.v$.$validate();
                if (this.v$.$error) {
                    this.isSubmitting=false;
                    for (var i = 0; i < this.v$.$errors.length; i++) {
                        console.log(this.v$.$errors[i].$message);
                    }
                    return;
                }
                
                this.leadObj.state = this.state != "" ? this.state : document.getElementById("state").value;
                this.leadObj.country = this.country;
                this.leadObj.leadSource = this.leadSource;
                this.leadObj.honeyPot = this.hpvalue;
                this.leadObj.requestTime = document.getElementById("loading-time").value;
                console.log(this.leadObj);
                this.axios
                    .post(getEndPoint(leadAPI), this.leadObj)
                    .then((response) => {
                            this.leadID = response.data.id;
                            this.submitSuccess = true;
                            this.submitFailure = false;
                            this.isSubmitting = false;
                        })
                    .catch((error) => {
                        this.submitFailure = true;
                        this.submitSuccess = false;
                        this.isSubmitting = false;
                        console.error("There was an error!", error);
                    });

                e.preventDefault();
            },
        },
    };
</script>